// Google Analytics event tracking utilities

// Declare gtag function for TypeScript
declare global {
  interface Window {
    gtag: (command: string, targetId: string, config?: any) => void;
  }
}

// Track form submission
export const trackFormSubmission = (formType: string, serviceType?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'form_submit', {
      event_category: 'engagement',
      event_label: formType,
      custom_parameter_1: serviceType || 'unknown',
      value: 1
    });
  }
};

// Track Calendly link clicks
export const trackCalendlyClick = (location: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'calendly_click', {
      event_category: 'engagement',
      event_label: location,
      value: 1
    });
  }
};

// Track page views for specific pages
export const trackPageView = (pageName: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      event_category: 'navigation',
      event_label: pageName,
      value: 1
    });
  }
};

// Track service interest
export const trackServiceInterest = (service: string, location: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'service_interest', {
      event_category: 'engagement',
      event_label: service,
      custom_parameter_1: location,
      value: 1
    });
  }
};

// Track conversion funnel step
export const trackConversionStep = (step: string, stepNumber: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion_step', {
      event_category: 'conversion',
      event_label: step,
      custom_parameter_1: `step_${stepNumber}`,
      value: stepNumber
    });
  }
};
